import React from 'react';
import PropTypes from 'prop-types';
import { Table, IconButton, Icon, Tooltip, Whisper } from 'rsuite';
import { modifyAccess } from '../../../../helpers/permission';
import * as PERMISSIONS from '../../../../constants/permissions/outreach';
import redirectTo from '../../../../helpers/redirectTo';
import AccessControl from '../../../AccessControl';

const { Cell } = Table;

const ActionCell = ({ rowData, dataKey, handleDelete, ...props }) => (
  <Cell {...props} className="link-group">
    <AccessControl allowOnlyFor={modifyAccess(PERMISSIONS.OUTREACH)}>
      <Whisper
        placement="top"
        trigger="hover"
        speaker={<Tooltip>Edit</Tooltip>}
      >
        <IconButton
          icon={<Icon icon="edit2" />}
          style={{ top: '-8px' }}
          appearance="link"
          size="md"
          circle
          onClick={() => {
            redirectTo(`/manage/outreach/edit/${rowData.id}/`);
          }}
        />
      </Whisper>
    </AccessControl>
  </Cell>
);

ActionCell.propTypes = {
  rowData: PropTypes.shape({
    id: PropTypes.number
  }),
  dataKey: PropTypes.string.isRequired,
  handleDelete: PropTypes.func
};

ActionCell.defaultProps = {
  rowData: null,
  handleDelete: () => {}
};

export default ActionCell;
